import React from "react";
import SectionHeader from "../../Components/SectionHeader/SectionHeader";
import AddBannerSection from "../../Components/SiteComponants/AddBannerSection";
import BannerListSection from "../../Components/SiteComponants/BannerListSection";
import BreadCrumbs from "./../../Components/BreadCrumbs/BreadCrumbs";
import { TitleSetup } from "../../Datas/Functions/titleSetup";
import { useState } from "react";

const ManageBanner = (meta) => {
  const [selectedBanner, setSelectedBanner] = useState();
  TitleSetup({ ...meta });
  return (
    <div className="container">
      <SectionHeader heading={"Banner Management"} />
      <BreadCrumbs texts={["Dashboard", "Manage Banner"]} />
      <div className="grid grid-cols-12 gap-4 my-10 ">
        <AddBannerSection selectedBanner={selectedBanner} />
        <BannerListSection setSelectedBanner={setSelectedBanner} />
      </div>
    </div>
  );
};

export default ManageBanner;
